import { ErrorState, Screen, Spinner } from '../../../../shared/ui/index.js';
import styles from './summary-state-screens.module.css';

export const SummaryLoadingScreen = () => (
  <Screen>
    <div className={styles.centered}>
      <Spinner label="Завантаження" />
    </div>
  </Screen>
);

type SummaryFailureScreenProps = {
  message: string;
  onRetry: () => void;
};

export const SummaryFailureScreen = ({ message, onRetry }: SummaryFailureScreenProps) => (
  <Screen>
    <ErrorState title="Не вдалося завантажити витрати" message={message} onRetry={onRetry} />
  </Screen>
);
